import {useMutation} from 'react-query';
import {useNavigate} from 'react-router-dom';
import decodeError from 'shared/util/decore-error';
import useApi from './use-api';
import {
  successNotification,
  errorNotification,
} from 'shared/services/notification';

interface Props {
  url?: string;
  getUrl?: (data: any) => string;
  method: string;
  errorTitle: string;
  successTitle?: string;
  successMessage?: ((data: any) => string) | string;
  redirectUrl?: ((data: any) => string) | string;
  onSuccess?: (data: any) => void;
  onSuccessRedirectUrlKey?: string;
  headers?: any | ((data: any) => any);
}

const useApiMutation = <T = any>({
  url,
  method,
  errorTitle,
  successTitle,
  successMessage,
  redirectUrl,
  onSuccess,
  getUrl,
  headers,
}: Props) => {
  const api = useApi();
  const navigate = useNavigate();

  const request = async (data: T) => {
    const response = await api({
      method,
      url: getUrl ? getUrl(data) : url,
      data,
      headers: typeof headers === 'function' ? headers(data) : headers,
    });

    return response.data.data;
  };

  return useMutation(url ?? new Date().toISOString(), request, {
    onSuccess: async (data) => {
      if (onSuccess) onSuccess(data);

      if (successTitle && successMessage)
        successNotification({
          title: successTitle,
          message:
            typeof successMessage === 'string'
              ? successMessage
              : successMessage(data),
        });

      if (redirectUrl) {
        console.log(
          typeof redirectUrl === 'string' ? redirectUrl : redirectUrl(data),
        );
        navigate(
          typeof redirectUrl === 'string' ? redirectUrl : redirectUrl(data),
        );
      }
    },
    onError: (error) =>
      errorNotification({
        title: errorTitle,
        message: decodeError(error),
      }) as any,
  });
};

export default useApiMutation;
